export function getElevationGain(input: number[]) {
	let res = _getElevationGain(input, 6)
	if (res.gain == 0 && res.loss == 0) {
		res = _getElevationGain(input, 2)
	}
	return res;
}

function _getElevationGain(input: number[], tolerance: number) {
	let ret = { gain: 0, loss: 0 }
	if (!Array.isArray(input) || input.length == 0)
		return ret;

	let lastElevation = input[0]

	for (let i = 1; i < input.length; ++i) {
		const diff = input[i] - lastElevation

		if (Math.abs(diff) > tolerance) {
			if (diff > 0) {
				ret.gain += diff
			} else {
				ret.loss += diff
			}
			lastElevation = input[i]
		}

	}
	return ret
}